import { Component } from 'react';

class ButtonApp extends Component {
    render() {
        let { _pageScope, ...others } = this.props;
        return _pageScope.props.button.createButtonApp(others);
    }
}

export default ButtonApp;